// Lecture défensive du token d'authentification.
// Historique: le token a pu être stocké brut (JWT) ou JSON.stringify(JWT).
// R28: on accepte les deux formes pour ne jamais dégrader une session en invité.
const KEY = 'elemental_duelists_auth_token';

export function readAuthToken() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const trimmed = raw.trim();
    if (trimmed.startsWith('"')) {
      try {
        const parsed = JSON.parse(trimmed);
        return typeof parsed === 'string' && parsed ? parsed : null;
      } catch (e) { /* JSON invalide: tenter brut */ }
    }
    // JWT brut (trois segments séparés par des points)
    if (trimmed.split('.').length === 3) return trimmed;
    return null;
  } catch (e) {
    return null;
  }
}

export function writeAuthToken(token) {
  if (!token) { localStorage.removeItem(KEY); return; }
  localStorage.setItem(KEY, JSON.stringify(token));
}
